import { slugify } from './slugifyString';
/**
 *
 * @param data An object with all the metrics in camelCase notation
 * @param name Name of the triggered event or description of the set of metrics
 * @returns A string that contains all GA metrics for the given elements inside the data object.
 */
export function getReadableLabel(data, ...name) {
    const items = [];
    const splitCamelCase = (key) => key.replace(/([A-Z])/g, ' $1').toLowerCase();
    Object.entries(data).forEach(([key, value]) => {
        items.push(`${slugify(splitCamelCase(key))}: ${value !== null && value !== void 0 ? value : ''}`);
    });
    return items.concat(name).join(' | ');
}
